import { render, staticRenderFns } from "./ScreenHeader.vue?vue&type=template&id=065264dc&scoped=true"
import script from "./ScreenHeader.vue?vue&type=script&lang=js"
export * from "./ScreenHeader.vue?vue&type=script&lang=js"
import style0 from "./ScreenHeader.vue?vue&type=style&index=0&id=065264dc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "065264dc",
  null
  
)

export default component.exports